module.exports = __webpack_public_path__ + "static/media/baseLogo.c8400637.psd";